<template>
    <b-modal
        id="add-lp-assignment-modal"
        v-model="modal"
        ref="add-lp-assignment-modal"
        size="md"
        :title="$t('learning_path.add_exercise')"
        modal-class="apprentice-default-modal add-assignment"
        :ok-title="$t('common.add')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <div class="lp-assignment-link">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    show
                    variant="danger">
                    {{ $t('learning_path.select_assignment') }}
                </b-alert>
            </div>
            <b-form-group
                class="assignments"
                label-for="assignment-multiselect"
                :label="$t('assignment.assignments')">
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="assignment"
                    :options="selectData">
                </b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: ['lpDeadlineIn'],
    name: 'design-2021-learning-path-deadline-student-add-assignment-modal-component',
    data() {
        return {
            lpAssignments: this.lpDeadlineIn.lp_assignments,
            assignment: null,
            studentId: null,
            modal: false,
            hasError: false,
        };
    },
    computed: {
        selectData() {
            let assignments = this.lpAssignments.map((assignment) => {
                return {
                    value: assignment.id,
                    text: assignment.lp_category.name + ' ' + assignment.name,
                    full: assignment.lp_signup_records.length >= assignment.max_students && assignment.max_students,
                };
            });

            assignments.unshift({
                value: null,
                text: this.$t('portfolio.results_choose_assignment'),
                disabled: true,
            });

            return assignments;
        },
    },
    methods: {
        show(studentId) {
            this.studentId = studentId;
            this.modal = true;
        },

        onOk(bvModelEvent) {
            this.hasError = false;

            if (this.assignment === null) {
                bvModelEvent.preventDefault();
                this.hasError = true;
                return;
            }

            const assignment = this.lpAssignments.find((assignment) => assignment.id === this.assignment);
            // if (assignment.lp_signup_records.length >= assignment.max_students && assignment.max_students) {
            //     this.alert.confirm('Opdracht is vol', 'Deze opdracht is vol je kan als docent over het limiet heen. Weet je zeker dat je dit wil?', 'toevoegen').then((confirm) => {
            //         if (confirm) {
            //             this.signUp()
            //         }
            //     });
            // } else {
            this.signUp();
            // }
        },

        signUp() {
            const data = {
                studentId: this.studentId,
                assignmentId: this.assignment,
                deadlineId: this.lpDeadlineIn.id,
            };
            this.alert.saving();
            this.axios
                .post(
                    this.routes.lpManagementAssignmentSignUp(
                        this.lpDeadlineIn.lp_deadline_series_id,
                        this.lpDeadlineIn.id,
                    ),
                    data,
                )
                .then(
                    (response) => {
                        this.$emit('addedAssignment', response.data);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
        },
    },
};
</script>

<style scoped></style>
